import { VIEWPORT_FONT_SIZE_IN_PX } from "./Constants";

export const toCleanText = (text) => {
  return text ? text.replace("&", "") : text;
};

export const toEM = (valueInPX) => {
  let result = valueInPX / VIEWPORT_FONT_SIZE_IN_PX;
  return result;
};

export const toPX = (valueInEM) => {
  let result = valueInEM * VIEWPORT_FONT_SIZE_IN_PX;
  return result;
};

export const safeParseJSONString = (content) => {
  try {
    return JSON.parse(content);
  } catch (error) {
    return content;
  }
};

export const isUiEvent = (args) => {
  return (args && args.event);
};